import { routerReducer, RouterReducerState } from '@ngrx/router-store'
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store'
import { storeFreeze } from 'ngrx-store-freeze'
import { environment } from '../../../environments/environment'
import * as fromAuth from './auth/auth.reducer'
import * as fromBroker from './broker/broker.reducer'
import * as fromClients from './clients.reducer'
import * as fromProgram from './program/program.reducer'
import * as fromTheme from './theme/theme.reducer'
import { State as AuthState } from './auth/auth.state.facade'
import { State as BrokerState } from './broker/broker.state.facade'
import { State as ProgramState } from './program/program.state.facade'
import { State as ThemeState } from './theme/theme.state.facade'
import { localStorageSync } from 'ngrx-store-localstorage'

export interface AppState {
  router: RouterReducerState
  auth: AuthState
  broker: BrokerState
  clients: fromClients.State
  program: ProgramState
  theme: ThemeState
}

function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [],
    rehydrate: true,
  })(reducer)
}

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  auth: fromAuth.reducer,
  broker: fromBroker.reducer,
  clients: fromClients.reducer,
  program: fromProgram.reducer,
  theme: fromTheme.reducer,
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? [(reducer: ActionReducer<AppState>) => reducer, localStorageSyncReducer, storeFreeze]
  : [localStorageSyncReducer]
